import Nullstack from 'nullstack';
export default function IconDisabled({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-disabled",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "11",
    cy: "5",
    r: "2"
  }), "   ", Nullstack.element("polyline", {
    points: "11 7 11 15 15 15 19 20"
  }), "   ", Nullstack.element("line", {
    x1: "11",
    y1: "11",
    x2: "16",
    y2: "11"
  }), "   ", Nullstack.element("path", {
    d: "M7 11.5a5 5 0 1 0 6 7.5"
  }), " ");
}